// extracted by mini-css-extract-plugin
export var navHolder = "breadcrumb-module--navHolder--GK3C0";